// @ts-check

import { Dropdown } from "antd";
import { useMemo } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Button from "~/components/Shared/Button";
import useOrganizationId from "~/hooks/useOrganizationId";
import useZeroSelector from "~/hooks/useZeroSelector";

export default function QuickLinksButton() {
    const orgId = useOrganizationId();
    const featureFlags = useZeroSelector((state) => state.org_helper.organization.feature_flags);

    const items = useMemo(() => {
        return [
            featureFlags.feed && {
                key: "create-post",
                label: <Link to={`/${orgId}/home/team/my_teams/feed/new_post`}>Create Post</Link>,
            },
            featureFlags.forms && {
                key: "submit-form",
                label: <Link to={`/${orgId}/home/team/my_teams/forms?modal=select-form`}>Submit Form</Link>,
            },
            featureFlags.incidents && {
                key: "create-incident",
                label: (
                    <Link to={`/${orgId}/home/incidents/location/all_locations?modal=select-location`}>
                        Create Incident
                    </Link>
                ),
            },
            featureFlags.courses && {
                key: "submit-course",
                label: <Link to={`/${orgId}/home/team/my_teams/courses?modal=select-form`}>Submit Course</Link>,
            },
            featureFlags.tasks && {
                key: "create-to-do",
                label: <Link to={`/${orgId}/home/todos?modal=create-task`}>Create To-do</Link>,
            },
        ].filter(Boolean);
    }, [orgId, featureFlags]);

    return (
        <Dropdown
            trigger={["click"]}
            menu={{items}}
        >
            <Button type="primary">Quick links</Button>
        </Dropdown>
    );
}
